import { render, staticRenderFns } from "./AutomatorBlockSingleRow.vue?vue&type=template&id=70ff0acc&scoped=true&"
import script from "./AutomatorBlockSingleRow.vue?vue&type=script&lang=js&"
export * from "./AutomatorBlockSingleRow.vue?vue&type=script&lang=js&"
import style0 from "./AutomatorBlockSingleRow.vue?vue&type=style&index=0&id=70ff0acc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ff0acc",
  null
  
)

export default component.exports